import { useTranslation } from 'react-i18next'

import type { SettlementStatusRoot } from '@repo/sdk'

import type { StatusConfig } from '../../components/StatusBadge'

export type SettlementStatusConfigMap = Record<SettlementStatusRoot, StatusConfig>

export function useSettlementStatusConfig(): SettlementStatusConfigMap {
  const { t } = useTranslation()

  return {
    PENDING: { color: 'orange', label: t('common.status.settlementPending') },
    PROCESSING: { color: 'blue', label: t('common.status.settlementProcessing') },
    COMPLETED: { color: 'green', label: t('common.status.settlementCompleted') },
    FAILED: { color: 'red', label: t('common.status.settlementFailed') },
    BLOCKED: { color: 'default', label: t('common.status.settlementBlocked') },
  }
}
